import {
  createRouter,
  createWebHistory
} from 'vue-router';
import authRoutes from './authRoutes';
import moduleRoutes from './moduleRoutes';
import pageRoutes from './pageRoutes';
import billingRoutes from './billingRoutes';
import ailabsRoutes from './ailabsRoutes';
import machineLabsRoutes from './machineLabsRoutes';
import { getCookie } from '@/utils/auth';

// Combine all routes
const routes = [
  ...authRoutes,
  ...moduleRoutes,
  ...pageRoutes,
  ...billingRoutes,
  ...ailabsRoutes,
  ...machineLabsRoutes
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Route Guards
router.beforeEach((to, from, next) => {
  const authToken = getCookie('authToken');

  if (to.meta.requiresAuth && !authToken) {
    next({
      path: '/login',
      query: {
        redirect: to.fullPath
      },
    });
  } else {
    next();
  }
});

// --- SEO: per-route title, meta description and canonical ---
const DEFAULT_DESCRIPTION =
  'Akademi Siber adalah platform belajar cyber security & ethical hacking: modul interaktif, lab mesin nyata via VPN, dan AI mentor 24/7. Mulai gratis dan naik peringkat.';

const ROUTE_DESCRIPTIONS = {
  '/': DEFAULT_DESCRIPTION,
  '/modules': 'Jelajahi modul cyber security Akademi Siber — jalur belajar terstruktur dari dasar hingga eksploitasi tingkat lanjut: web, jaringan, kripto, dan banyak lagi.',
  '/machine-labs': 'Machine Labs Akademi Siber — boot mesin rentan nyata lewat VPN dan latih kemampuan exploitasi seperti pentester profesional.',
  '/ai-labs': 'AI Mentored Lab — berlatih dengan bimbingan AI mentor 24/7 yang memberi petunjuk kontekstual saat kamu menyelesaikan tantangan.',
  '/leaderboard': 'Leaderboard Akademi Siber — kumpulkan poin, naik peringkat dari Kiddie ke Mastermind, dan bersaing dengan hacker dari seluruh dunia.',
  '/subscribe': 'Upgrade ke Premium Akademi Siber — akses semua modul eksklusif, 500 pesan AI mentor/minggu, dan 50 mesin/minggu.',
  '/login': 'Masuk ke akun Akademi Siber kamu untuk melanjutkan belajar cyber security.',
  '/register': 'Daftar gratis di Akademi Siber dan mulai perjalanan belajar ethical hacking kamu hari ini.',
};

function setMeta(name, content, attr = 'name') {
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setCanonical(url) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', url);
}

router.afterEach((to) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  const description = ROUTE_DESCRIPTIONS[to.path] || DEFAULT_DESCRIPTION;
  setMeta('description', description);
  setMeta('og:title', to.meta.title || document.title, 'property');
  setMeta('og:description', description, 'property');
  setMeta('twitter:description', description);

  const canonical = `${window.location.origin}${to.path}`;
  setCanonical(canonical);
  setMeta('og:url', canonical, 'property');
});

export default router;